let itm = {
  // bcg: require('../bcg_unit.png'),
  bcg2: require('./u9.png'),
  name: 'In the playground',
  items: [],
};

export default itm;
